// images and logo
import logo from './logo.svg';
import Click from './components/Click.js';
import Jumbotron from 'react-bootstrap/Jumbotron';
import ScrollToTop from './ScrollToTop.js';

import MoreContent from "./components/MoreContent.js";
import Nav from 'react-bootstrap/Nav'
// css style
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

// componets
import SideNave from './components/SideNave.js';
import Content from './components/Content.js';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Alert from 'react-bootstrap/Alert';
import Media from 'react-bootstrap/Media';
import ListGroup from 'react-bootstrap/ListGroup';
import Card from 'react-bootstrap/Card';
import Figure from 'react-bootstrap/Figure';
import ContentAds from './components/ads/ContentAds.js'

import BarPro from './BarPro.js';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  Redirect,
} from "react-router-dom";
function App() {
  const barload = true;

  return (

    <Container>
    <Router>
      <ScrollToTop />

      <Row>
          <Col xs="12" md="4" lg="3" sm="4">
              <SideNave />

          </Col>

          <Col xs="12" md='8' lg="9" sm="8">
              <Content />
              {/*
                <Row>
                    <Col xs="12" md='12' lg="12" sm="12">
                        <ContentAds />
                    </Col>

                </Row>
                */}
          </Col>
      </Row>

      <MoreContent />

      <Row>
        <Col>
        <Jumbotron className="bg-secondary" fluid>
          <p className="copyright">
          &copy; Copyright réservés {new Date().getFullYear()}: <a href="https://mathsriyadiyat.github.io" style={{color:"#fff"}}>Mathsriyadiyat</a>
          </p>
        </Jumbotron>
        </Col>
      </Row>

    </Router>
    </Container>
  );
}

export default App;
